import { element } from './util.ts';

export const isEditorPopup = (target: EventTarget | null): boolean => {
  return !!element(target)?.closest('[data-editor-popup="true"]');
};
